import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class PadlockEventsService {
  userProvisioned$: Subject<void> = new Subject<void>();

  constructor() {}
}
